<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <div class="consoleHeader" consoleHeaderOffset
    [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
        <div class="row flex-nowrap">
            <div class="col-auto header_section pr-2">
                <div
                    *ngIf="masterService.LoggedInUserData.Properties.length > 1"
                    ngbDropdown
                    #ddProperty="ngbDropdown"
                    class="dropdown-noarrow align-self-center"
                    placement="bottom-left"
                    autoClose="outside"
                    (openChange)="onPropertyOpened($event)"
                >
                    <button
                        type="button"
                        class="btn btn-link firstFilter"
                        title="{{'TITLE.TITLE_SELECT_PROPERTIES' | translate}}"
                        ngbDropdownAnchor
                        (click)="$event.stopPropagation(); ddProperty.toggle()"
                        [ngClass]="(RequestModel.Properties.length > 1 ? 'propSelected' : '')"
                    >
                        <i class="ksv-icon-building"></i>
                    </button>
                    <div
                        class="dropdown-menu scrollable-dropdown-menu"
                        ngbDropdownMenu
                    >
                        <div
                            class="dropdown-header"
                            style="padding: 0.5rem 2.75rem"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="IsAllSelected()"
                                [indeterminate]="IsSomeSelected()"
                                (change)="MasterToggle($event)"
                                id="chk_prop_master_job"
                            />

                            <label
                                class="form-check-label text-nowrap"
                                for="chk_prop_master_job"
                            >{{"LBL.SELECT_PROPERTIES" | translate}}</label
                            >
                        </div>
                        <div class="px-4">
                            <div
                                class="form-check"
                                *ngFor="let row of lstProperties"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="chk_prop_{{row.PropertyId}}"
                                    [value]="row.PropertyId"
                                    [checked]="idxPropSelectedDropDown(row.PropertyId) >= 0"
                                    (change)="onPropertySelected(row.PropertyId, $event)"
                                />
                                <label
                                    class="form-check-label text-nowrap"
                                    for="chk_prop_{{row.PropertyId}}"
                                >{{row.PropertyName}}</label
                                >
                            </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="px-4">
                            <button
                                class="btn btn-secondary btn-sm"
                                type="button"
                                (click)="onPropertyChange(); ddProperty.close()"
                                translate
                            >
                                BTN.BTN_SAVE
                            </button>
                        </div>
                        <!--<button class="dropdown-item" *ngFor="let row of masterService.LoggedInUserData.Properties" [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}" (click)="RequestModel.PropertyId = row.PropertyId">{{row.PropertyName}}</button>-->
                    </div>
                </div>
            </div>

            <div class="col-auto header_section">
                <div
                    ngbDropdown
                    #ddView="ngbDropdown"
                    class="align-self-center"
                    placement="bottom-left"
                >
                    <div class="d-flex align-items-center">
                        <!--<i class="ksv-icon-views mr-2"></i>-->
                        <a
                            href="javascript:{}"
                            class="btn-nonlink"
                            ngbDropdownToggle
                        >{{'BTN.BTN_MY_VIEW' | translate}}</a
                        >
                    </div>

                    <div class="dropdown-menu" ngbDropdownMenu>
                        <button
                            type="button"
                            class="dropdown-item pointer"
                            title=""
                            (click)="onAssignedToMe()"
                            *ngIf="isServiceStaff()"
                            [ngClass]="(RequestModel.AssignedTo != null && RequestModel.AssignedTo.length == 1 && RequestModel.AssignedTo[0] == masterService.LoggedInUserData.StaffId) ? 'highlight_Color': ''"
                        >
                            {{'TITLE.TITLE_ASSIGNED_TO_ME' | translate}}
                        </button>
                        <button
                            type="button"
                            class="dropdown-item pointer"
                            title=""
                            (click)="onLoggedToMe()"
                            [ngClass]="(RequestModel.LoggedBy != null && RequestModel.LoggedBy.length == 1 && RequestModel.LoggedBy[0] == masterService.LoggedInUserData.StaffId) ? 'highlight_Color': ''"
                        >
                            {{'TITLE.TITLE_LOGGED_BY_ME' | translate}}
                        </button>
                        <div class="dropdown-divider"></div>
                        <button
                            class="dropdown-item pointer"
                            type="button"
                            (click)="onFilterSave()"
                        >
                            {{'TITLE.TITLE_SAVE_VIEW' | translate}}
                        </button>
                        <button
                            class="dropdown-item pointer"
                            type="button"
                            (click)="onLoadFilter()"
                        >
                            {{'TITLE.TITLE_LOAD_VIEW' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-auto topFilters header_section headerlink-2line">
                <a
                    *ngFor="let row of PropStatModel"
                    title="{{(row.Id == null) ? ('TITLE.TITLE_ALL_JOBS' | translate) : (('TITLE.TITLE_'+row.Id+'_JOBS') | translate)}}"
                    [ngClass]="(RequestModel.StatusCode == row.Id ? 'active' : '')"
                    href="javascript:{}"
                    (click)="onTopFilter(row.Id)"
                    class=""
                >
                    <div translate class="topFilter_Label text-center">
                        {{row.Label}}
                    </div>
                    <div class="small text-center">({{row.Value}})</div>
                </a>
            </div>

            <div class="col-auto d-flex align-items-center header_section">
                <div class="searchFilterResult">
                    <input
                        type="text"
                        [placement]="['bottom']"
                        [(ngModel)]="KeywordSearch"
                        [ngbTypeahead]="SearchString"
                        [editable]="false"
                        [resultTemplate]="SearchResult"
                        class="form-control searchFilter_Text"
                        (selectItem)="onSearchFilter($event)"
                        [inputFormatter]="SearchFilter_DisplayText"
                    />
                </div>
            </div>

            <div class="col-auto d-flex align-items-center header_section">
                <div
                    class="w-auto"
                    title="{{'TITLE.TITLE_GROUP_BY' | translate}}"
                >
                    <select
                        class="custom-select"
                        [(ngModel)]="RequestModel.GroupBy"
                        (change)="onGroupingChanged()"
                    >
                        <option
                            *ngFor="let row of GroupTypes"
                            [ngValue]="row.Id"
                        >
                            {{row.Name | uppercase | translate}}
                        </option>
                    </select>
                </div>
                <div class="align-items-center" *ngIf="RequestModel.GroupBy">
                    <div
                        class="ml-4 pointer"
                        (click)="onClearGrouping()"
                        *ngIf="RequestModel.GroupBy"
                    >
                        <strong><i class="fas fa-times fa-lg mr-2"></i></strong
                        >Clear Grouping
                    </div>
                </div>
            </div>

            <div
                class="col-auto d-flex header_section align-items-center px-4"
                [ngClass]="RequestModel.HasFilters ? 'backHightlight':''"
            >
                <div
                    class="pointer"
                    (click)="jobFilter.onOpen(RequestModel)"
                    title="{{'TITLE.TITLE_FILTERS' | translate}}"
                >
                    <i class="fas fa-filter"></i>
                </div>
                <div
                    class="ml-4 pointer"
                    (click)="onClearFilter()"
                    *ngIf="RequestModel.HasFilters"
                >
                    <i class="fas fa-times fa-lg mr-2"></i
                    >{{'TITLE.TITLE_CLEAR_FILTER' | translate}}
                </div>
            </div>

            <div
                class="col-auto mr-4 header_section d-none"
                *ngIf="complainService.Cache_UpdatedComplains.length > 0"
            >
                <a
                    href="javascript:{}"
                    class="text-danger"
                    (click)="onResetToAll()"
                ><i
                    class="fas fa-exclamation-triangle"
                    title="{{complainService.Cache_UpdatedComplains.length}} {{'TITLE.TITLE_JOBS_UPDATED' | translate}}"
                ></i
                ></a>
            </div>

            <div class="col d-flex justify-content-end">
                <!--<a href="javascript:{}" class="mr-3 btn-nonlink" (click)="RefreshData()" title="{{'TITLE.TITLE_REFRESH' | translate}}"><i class="fa-lg ksv-icon-refresh"></i></a>-->
                <div class="header_section align-items-center px-3">
                    <div
                        class="pointer"
                        (click)="OpenKeyModal()"
                        title="{{'TITLE.TITLE_LEGENDS' | translate}}"
                    >
                        <i class="fa fa-lg fa-key fa-fw"></i>
                    </div>
                </div>
                <div class="header_section align-items-center px-3">
                    <div
                        class="pointer"
                        (click)="RefreshData()"
                        title="{{'TITLE.TITLE_REFRESH' | translate}}"
                    >
                        <i class="fa fa-lg fa-sync-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="jobconsole-body"
        [ngClass]="CheckAuth_Action(_AuthActionCodes.CallRegistration)? '':'pb-0'"
    >
        <div [hidden]="RequestModel.GroupBy != _ComplainSearch_GroupBy.None">
            <JobSearchResult
                #crisisSearchResult
                [RequestModel]="RequestModelCrisis"
                [Mode]="Search_Mode"
                (onSelected)="onSelected($event)"
            ></JobSearchResult>
            <JobSearchResult
                #jobSearchResult
                [RequestModel]="RequestModel"
                (onSelected)="onSelected($event)"
            ></JobSearchResult>
        </div>

        <div
            *ngIf="Model != null && RequestModel.GroupBy != _ComplainSearch_GroupBy.None && Model.Result && Model.Result.length > 0"
        >
            <div *ngFor="let row of Model.Result; let index=index;" class="row">
                <div class="col" *ngIf="index<100">
                    <JobSearchGroup
                        [RequestModel]="RequestModel"
                        [Model]="row"
                    ></JobSearchGroup>
                </div>
            </div>
            <div
                class="d-flex justify-content-center noRecords"
                *ngIf="Model.Result.length >100"
                translate
            >
                LBL.DISCLAIMER_GROUPING_LIMIT
            </div>
        </div>
        <div
            *ngIf="Model != null && RequestModel.GroupBy != _ComplainSearch_GroupBy.None && !IsSubmitting && (Model.Result == null || Model.Result.length == 0)"
            class="noRecords"
        >
            <span translate>LBL.NO_RECORD_FOUND</span>
        </div>
    </div>
</div>

<ng-template #SearchResult let-row="result" let-t="term" class="">
    <div class="d-flex justify-content-between align-items-center">
        <div class="w-auto d-flex align-items-center">
            <div
                class="w-auto mr-2"
                title="{{'TITLE.TITLE_SEARCH' | translate}}"
            >
                <div class="searchIcon"><i class="fas fa-search"></i></div>
            </div>
            <div class="w-auto mr-2">{{t}}</div>
        </div>
        <div class="w-auto">
            <div class="entityName text-muted">
                {{'ENTITIES.ENTITIES_' + row.EntityName | uppercase |
                translate}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #consoleKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 d-flex">
                <div class="text-danger col-1 d-flex">
                    <div>
                        <i class="fas fa-arrow-up"></i>
                    </div>
                    <div class="pl-1">7</div>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_ESCALATION_SYMBOL_LEVEL
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-OPN"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_OPEN_JOBS</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-USN"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_USN_JOB</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-PRK"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_PARKED_JOB</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-SNL"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_SNL_JOB</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-CLS border-0"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_CLOSED_JOB</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-map-marker-alt"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_LOCATION</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-briefcase"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GUEST</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="ic-status active col-1">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GUEST_VIP</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-paperclip"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_ATTACHMENT</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-lock-open"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_REG_DATE_TIME
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="ic-status active col-1">
                    <i class="fas fa-lock-open"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_REG_DATE_TIME_REOPEN
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-building"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_PROPERTY</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-filter"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_JOB_FILTER</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_REFRESH</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="far fa-clock"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_MSG_SENDING</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <i
                        class="ksv-icon-double-check deliveryICON deliveryICON-O"
                    ></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_MSG_DELIVERED
                </div>
            </div>
            <!--<div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="ksv-icon-double-check deliveryICON deliveryICON-GB"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_MSG_READ_PARTIAL
                </div>
            </div>-->
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <i
                        class="ksv-icon-double-check deliveryICON deliveryICON-G"
                    ></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_MSG_READ_PARTIAL
                </div>
                <!-- ICON_DEF.ICON_DEF_MSG_READ_ALL -->
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-on statusIcon-Sucess"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_SUCCESS
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="statusIcon col-1 connectionIcon">
                    <i class="ksv-icon-connection-off statusIcon-Error"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_FAIL
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-bell"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_NOTIFICATION</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="fas fa-sort"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_SORT</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="ksv-icon-reset-job"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_RESET</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <!-- <div class="col-1 gsrEnabled">
                    <i class="fas fa-clipboard-check"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_GSR</div> -->
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1"><i class="fas fa-lock"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CLOSED_DATE_TIME
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1 LoggedInStatus">
                    <i class="fas fa-user"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_LOGGIN_USER</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1 LoggedOutStatus">
                    <i class="fas fa-user"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_LOGGED_OUT</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="ksv-icon-expand"></i></div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_EXPAND</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1 usr-info">
                    <i class="fas fa-info-circle"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_USR_INFO</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <i class="icon-html-icons_collapse"></i>
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_COLLAPSE</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <div
                        class="text-center statusIcon-Standard status-DUP"
                        title=""
                    ></div>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_DUPLICATE_JOB
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1"><i class="text-danger kmt-icons kmt-icon-construction"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_WORKORDER
                </div>
                <div class="pl-3" translate>ICON_DEF.ICON_DEF_WORKORDER</div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <i
                        class="kmt-icons kmt-icon-construction kmt-wo-button"
                    ></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_MANNUAL_WORKORDER
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <img
                    class="icon-priority"
                    src="/Images/UFIcons/Normal.svg"
                    />
                </div>
                <div class="pl-3">
                    <span translate>LBL.LBL_NORMAL </span>
                    <span translate>LBL.LBL_PRIORITY</span>
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <img
                    class="icon-priority"
                    src="/Images/UFIcons/Urgent.svg"
                    />
                </div>
                <div class="pl-3">
                    <span translate>LBL.LBL_URGENT </span>
                    <span translate>LBL.LBL_PRIORITY</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex">
                <div class="col-1">
                    <img
                    class="icon-priority"
                    src="/Images/UFIcons/Extra_urgent.svg"
                    />
                </div>
                <div class="pl-3">
                    <span translate>LBL.LBL_EXTRA_URGENT </span>
                    <span translate>LBL.LBL_PRIORITY</span>
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="col-1">
                    <img
                    class="icon-priority"
                    src="/Images/UFIcons/brightness_alert.svg"
                    />
                </div>
                <div class="pl-3">
                    <span translate>LBL.LBL_CRISIS </span>
                    <span translate>LBL.LBL_PRIORITY</span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary mr-3"
            (click)="c('close')"
            translate
        >
            BTN.BTN_OK
        </button>
    </div>
</ng-template>

<JobPopover #jobPopover [Selected]="complainService._SelectedJob"></JobPopover>
<JobFilter #jobFilter (ApplyFilter)="SetData();SetTopStatusData();"></JobFilter>
<RegisterCall
    *ngIf="CheckAuth_Action(_AuthActionCodes.CallRegistration)"
    [DisplayMode]="2"
></RegisterCall>
